import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {rbacActions} from "../../config/rbac/actions.ts";

import {AddPage as AddProductLineItemPage} from '../product-line-items/pages/AddPage'
import {EditPage as EditProductLineItemPage} from '../product-line-items/pages/EditPage'

import {AddPage as AddPricePage} from '../prices/pages/AddPage'
import {EditPage as EditPricePage} from '../prices/pages/EditPage'
import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";

export const ProductsLayout = () => {


    return (
        <Routes>
            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListProducts}>
                    <IndexPage/></RestrictedRouteElement>}
            />
            <Route
                path='add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateProduct}>
                    <AddPage/></RestrictedRouteElement>}
            />
            <Route
                path=':id'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetProduct}>
                    <EditPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/product-line-items/add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateProductLineItem}>
                    <AddProductLineItemPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/product-line-items/:productLineItemId'
                element={<RestrictedRouteElement rbacAction={rbacActions.UpdateProductLineItem}>
                    <EditProductLineItemPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/prices/add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreatePrice}>
                    <AddPricePage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/prices/:priceId'
                element={<RestrictedRouteElement rbacAction={rbacActions.UpdatePrice}>
                    <EditPricePage/></RestrictedRouteElement>}
            />

        </Routes>
    );
};
